import { getPendingChangeOutlinedHighlightStyles } from '@sharedCR/common/form/shared/styles';

import { getConditionalObject } from 'utils/data';

// The disabled state previously hardcoded rgba(0,0,0,0.26), which stays dark-on-dark in dark mode
// and renders the disabled label/outline near-invisible. Keep the exact light value and flip to the
// dark palette's disabled token in dark mode.
const getDisabledColor = palette =>
  palette.mode === 'dark' ? palette.text.disabled : 'rgba(0, 0, 0, 0.26)';

const getColorStyles = ({ error, disabled, palette }) => {
  if (error) {
    return palette.text.error;
  }

  if (disabled) {
    return getDisabledColor(palette);
  }

  return null;
};

export const getStyles = ({ error, disabled, isFieldChanged, columns }) => ({
  controlLabel: {
    color: ({ palette }) => (error ? palette.text.error : null),
    width: 'fit-content',
    gap: '4px',
    margin: 0,
    zIndex: 1,

    ...getConditionalObject(isFieldChanged, () => getPendingChangeOutlinedHighlightStyles(columns)),

    '.MuiCheckbox-root': {
      padding: '7px',
    },

    '& .MuiFormControlLabel-asterisk': {
      marginLeft: '4px',
      lineHeight: '2rem',
      color: ({ palette }) => palette.text.error,
    },

    '& .checkbox-label': {
      paddingRight: '7px',
      color: ({ palette }) => `${getColorStyles({ error, disabled, palette })} !important`,
    },
  },
  checkbox: {
    ...getConditionalObject(error, {
      color: ({ palette }) => palette.text.error,
    }),

    '& .checkbox-icon rect': {
      stroke: ({ palette }) => `${getColorStyles({ error, disabled, palette })} !important`,
    },
  },
});
